
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/exercises/[tool]/[slug]",
      function () {
        return require("private-next-pages/exercises/[tool]/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/exercises/[tool]/[slug]"])
      });
    }
  